import React from "react";
import { useTheme } from "../../hooks/useTheme";
import styles from "./ProductHeader.module.scss";
import BackButton from "../backButton/BackButton";
import { FavoriteScreenButton } from "../favoriteScreenButton/FavoriteScreenButton";

interface ProductHeaderProps {
  title: string;
  isFavorite: boolean;
  onFavoritePress?: () => void;
  showFavorite?: boolean;
  textColor?: string;
  borderColor?: string;
  // backgroundColor?: string;
  rightContent?: React.ReactNode;
}

export const ProductHeader: React.FC<ProductHeaderProps> = ({
  title,
  isFavorite,
  onFavoritePress,
  showFavorite = true,
  textColor,
  borderColor,
  // backgroundColor,
  rightContent,
}) => {
  const { theme } = useTheme();

  // const finalBackgroundColor = backgroundColor ?? theme.background;
  const finalTextColor = textColor ?? theme.text;

  return (
    <header
      className={styles.header}
      // style={{
      //   borderBottomColor: finalBorderColor,
      //   backgroundColor: finalBackgroundColor,
      // }}
    >
      <BackButton likeText />

      <h1 className={styles.headerTitle} style={{ color: finalTextColor }}>
        {title}
      </h1>

      <div className={styles.headerActions}>
        {rightContent}
        {showFavorite && onFavoritePress && (
          <FavoriteScreenButton
            isFavorite={isFavorite}
            onPress={onFavoritePress}
            color={theme.textSecondary}
            activeColor={theme.danger}
          />
        )}
      </div>
    </header>
  );
};
